import { all, fork, put, takeLeading } from 'redux-saga/effects';
import ApiConstants from 'src/common/helpers/ApiConstants';
import * as requests from 'src/common/helpers/HTTPRequest';
import { toastError, toastWarning } from 'src/common/helpers/Notifications';
import TextConstants from 'src/common/helpers/TextConstants';
import Utils from 'src/common/helpers/Utils';
import { DEVICE_TYPE, GSP_PERIOD_TIMES, MZ_DATA } from '../constants';
import {
  getSensorsGPSHistoryError,
  getSensorsGPSHistorySuccess,
  getSensorsPositionError,
  getSensorsPositionSuccess,
  sensorsGPSDashboardActions,
} from './actions';

function* getLastDevicesGPS({ payload }) {
  try {

    const { periodTime, startTime, endTime } = payload;
    let periodActiveTimeRange = null;
    if (periodTime !== GSP_PERIOD_TIMES.NO_JUDGMENT) {
      periodActiveTimeRange = {
        start: new Date(startTime).getTime(),
        end: new Date(endTime).getTime(),
      };
    }

    const gpsRequest = [
      requests.getRequest(
        `${ApiConstants.BASE_URL}${ApiConstants.GPS_RECEIVERS}`,
        {}
      ),
      requests.getRequest(
        `${ApiConstants.BASE_URL}${ApiConstants.GPS_LOGGERS}`,
        {}
      ),
    ];

    const results = yield all(gpsRequest);
    const gatewaysGPS = results[0];
    const loggerGPS = results[1];

    const receiverCoordinatesSet = new Set();

    const gatewaysGPSTranformed = Utils.transformGatewayGPSData(
      gatewaysGPS,
      periodActiveTimeRange,
      receiverCoordinatesSet
    );
    const loggersGPSTranformed = Utils.transformLoggerGPSData(
      loggerGPS,
      periodActiveTimeRange,
      receiverCoordinatesSet
    );

    const devicesGPSData = gatewaysGPSTranformed.concat(loggersGPSTranformed);

    yield put(getSensorsPositionSuccess(devicesGPSData));
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put(getSensorsPositionError());
  }
}

const getTemperature = (sensorType, ch1) => {
  if (
    ![MZ_DATA.A2_VALUE.PULSE, MZ_DATA.A2_VALUE.VOLTAGE].includes(sensorType)
  ) {
    return ch1;
  }
  return null;
};

function* getSensorGPSHistory({ payload }) {
  try {

    let isNoDataForAll = true;
    const { ids, startDate, endDate } = payload;
    const queryString = `?startTime=${startDate}&endTime=${endDate}`;

    const requestList = ids.map((idData) => {
      const queryStringUpdated = `${queryString}&deviceType=${idData.type}`;
      return requests.getRequest(
        `${ApiConstants.BASE_URL}${ApiConstants.GPS_DEVICE_HISTORY.replace(
          '{:deviceId}',
          idData.id
        )}/${queryStringUpdated}`,
        {}
      );
    });
    const allRes = yield all(requestList);
    const histories = [];
    const randomColors = Utils.getRandomHEXColors(ids.length);

    for (let k = 0; k < ids.length; k++) {
      const { id, type } = ids[k];

      const historyTimestamps = new Set();
      let history = (allRes[k] || [])
        .filter((dataPoint) => {
          // Filter the duplicated timestamp
          const timestamp = dataPoint[0];
          if (!historyTimestamps.has(timestamp)) {
            historyTimestamps.add(timestamp);
            return true;
          }
          return false;
        })
        .map((data) => {
          return {
            id,
            timestamp: data[0],
            lat: data[1],
            lng: data[2],
            temperature:
              type === DEVICE_TYPE.LOGGER
                ? getTemperature(data[3], data[4])
                : null,
          };
        });

      if (history.length) {
        isNoDataForAll = false;
      }

      histories.push({
        history,
        type,
        id,
        pathColor: ids.length === 1 ? 'red' : randomColors[k], // Default red when only one device selected
      });
    }

    if (isNoDataForAll) {
      toastWarning(TextConstants.Common.NoData);
    }

    yield put(getSensorsGPSHistorySuccess(histories));
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put(getSensorsGPSHistoryError());
  }
}

export function* watchGPSDashboard() {
  yield takeLeading(
    sensorsGPSDashboardActions.GET_LAST_DEVICES_GPS,
    getLastDevicesGPS
  );
  yield takeLeading(
    sensorsGPSDashboardActions.GET_SENSORS_GPS_HISTORY,
    getSensorGPSHistory
  );
}

export default function* rootSaga() {
  yield all([fork(watchGPSDashboard)]);
}
